import { INode } from "../../@types/device";
import { ServiceContextType } from "../../@types/service";
import { Button } from "@headlessui/react";
import { asArray, rawValue } from "../../lib/node";
import { useSetter } from "../../lib/useSetter";

export default function Buttons({
  node,
  ctx,
}: {
  node: INode;
  ctx: ServiceContextType;
}) {
  const { setValue, disabled } = useSetter();
  const buttons = asArray(node.buttons);
  const current = rawValue(ctx, node.addr, node.stateKey);

  if (!buttons.length)
    return <div className="mt-4 text-sm opacity-40">No buttons configured.</div>;

  return (
    <div className="flex flex-wrap justify-between mt-4">
      {buttons.map((b, i) => (
        <Button
          key={i}
          disabled={disabled}
          onClick={() => setValue(node.addr, node.stateKey, b.value)}
        >
          <div
            className={
              "w-20 mb-4 text-center rounded-md py-2 px-4 border border-gray-400" +
              (current === b.value
                ? " bg-indigo-400 border-indigo-400 text-white"
                : " text-gray-400")
            }
          >
            {b.label}
          </div>
        </Button>
      ))}
    </div>
  );
}
